import {WalkOfShame} from "../WalkOfShame";
import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";

export class WalkOfShameAnticipation extends PIXI.Container {
    private _item: PIXI.spine.Spine;
    private readonly _fadeIn: TimelineLite;
    private readonly _fadeOut: TimelineLite;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.ANTICIPATION)?.addChild(this);
        this.init();

        this._fadeIn = new TimelineLite({
            paused: true
        });
        this._fadeIn.add(() => {
            if (!this._item.visible) {
                this._item.visible = true;
                this._item.alpha = 0;
                this._item.updateTransform();

                this._item.state.setAnimation(0, "animation", false);

                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.S_ANTICIPATION,
                    volume: 1
                });
                WalkOfShameSound.fadeMusic(0.5, 500);
            }
        });
        this._fadeIn.to(this._item, {
            duration: 0.1,
            alpha: 1
        });

        this._fadeOut = new TimelineLite({
            paused: true
        });
        this._fadeOut.add(() => {
            WalkOfShameSound.fadeAndStopSound({
                name: WalkOfShameSound.S_ANTICIPATION,
                to: 0,
                duration: 50
            });

            // next mode is any of FS
            if (WalkOfShame.model.parsedGameData.nextMode.indexOf("FREESPIN") > -1) {
                WalkOfShameSound.fadeMusic(0, 500);

                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.S_ANTICIPATION_SUCCESS
                });
            } else {
                WalkOfShameSound.fadeMusic(1, 500);

                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.S_ANTICIPATION_FAIL
                });
            }
        });
        this._fadeOut.to(this._item, {
            duration: 0.1,
            alpha: 0
        });
        this._fadeOut.add(() => {
            this._item.visible = false;
            this._item.alpha = 1;

            this._item.state.clearTracks();
        });
    }

    public playAnticipation(reelId: number): void {
        if (this._fadeOut) {
            this._fadeOut.pause();
            this._fadeOut.kill();
        }

        this._item.x = (reelId * 144) + (144 / 2);
        if (!this._item.visible) {
            this._fadeIn.play(0);
        } else {
            this._item.state.setAnimation(0, "animation", false);
        }
    }

    public stopAnticipation(): void {
        if (this._fadeIn) {
            this._fadeIn.pause();
            this._fadeIn.kill();
        }

        if (!this._item.visible) {
            return;
        }

        WalkOfShame.blackOverlay.hideOverlay(0.1);
        this._fadeOut.play(0);
    }

    private init(): void {
        this._item = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("anticipation"));
        this._item.visible = false;
        this._item.y = 400;

        this.addChild(this._item);
    }
}